import Vue from 'vue'
import Buefy from 'buefy'

Vue.use(Buefy)

let vue = new Vue()

export default class AppToast {
    success(msg) {
        return vue.$toast.open({
            duration: 2000,
            message: msg,
            position: 'is-top',
            type: 'is-success'
        })
    }

    danger(msg) {
        return vue.$toast.open({
            duration: 2000,
            message: msg,
            position: 'is-top',
            type: 'is-danger'
        })
    }
}